import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';
import GenericTable from 'componentes/generic/GenericTable.js';

const ClasificacionesQuejaWmTable = ({
  clasificacionesQueja,
  setIdClasificacionesQuejaToEdit,
  setOpenModal
}) => {
  const columns = [
    {
      accessorKey: 'clave',
      header: 'Clave',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'descripcion',
      header: 'Clasificacion',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'idclasificacionquejawm',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idclasificacionquejawm } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdClasificacionesQuejaToEdit(idclasificacionquejawm);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
          </>
        );
      }
    }
  ];
  return (
    <>
      <GenericTable
        data={clasificacionesQueja}
        title="Clasificaciones de Queja Walmart"
        columns={columns}
        addAction={() => {
          setIdClasificacionesQuejaToEdit(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};
ClasificacionesQuejaWmTable.propTypes = {
  clasificacionesQueja: PropTypes.array.isRequired,
  setIdClasificacionesQuejaToEdit: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};
export default ClasificacionesQuejaWmTable;
